import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen';
import { bootstrap } from './app/bootstrap';
import { queryClient } from './app/api';
import { AppErrorBoundary, installChunkReload } from './app/chunkReload';
import './styles.css';

installChunkReload();

const router = createRouter({ routeTree, defaultPreload: 'intent', context: { app: __APP__ } });
declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}

const { Providers } = bootstrap();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Providers>
          <RouterProvider router={router} />
        </Providers>
      </QueryClientProvider>
    </AppErrorBoundary>
  </React.StrictMode>,
);
